module.exports = __webpack_public_path__ + "static/media/NumberCircle-05.5211be30.svg";